import { Button } from "@/components/ui/Button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/Tooltip";
import { cn } from "@/lib/utils";
import React from "react";

interface RoundButtonWithIconProps {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  text?: string;
  ariaLabel?: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  className?: string;
  iconClassName?: string;
  stopPropagation?: boolean;
}

export const RoundButtonWithIcon: React.FC<RoundButtonWithIconProps> = ({
  icon: Icon,
  text = "",
  ariaLabel = "",
  onClick,
  disabled = false,
  className = "",
  iconClassName = "",
  stopPropagation = false,
}) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (stopPropagation) {
      event.preventDefault();
      event.stopPropagation();
    }

    onClick(event);
  };

  return (
    <div className="relative group">
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              type="button"
              variant="outline"
              size="icon"
              onClick={handleClick}
              aria-label={ariaLabel || text || undefined}
              disabled={disabled}
              className={cn(
                "rounded-full border-transparent p-2 hover:border-input",
                className,
              )}
            >
              <Icon
                className={cn(
                  "size-5 transition-transform group-hover:scale-110",
                  iconClassName,
                )}
              />
            </Button>
          </TooltipTrigger>
          {text !== "" && (
            <TooltipContent side="top" sideOffset={15}>
              {text}
            </TooltipContent>
          )}
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};
